import { useEffect, useState } from "react";
import { cacheService, oktaService } from "../../Core/Api/services";
import { useNavigate } from "react-router";
import { routePaths } from "../../Router/router";
import { LoginOktaRequest } from "../../Core/Api/Types/login-okta-request";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LoginOkta = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const params = window.location.search;
    const urlParams = new URLSearchParams(params);
    const code = urlParams.get("code");
    const codeVerifier = cacheService.GetOktaCodeVerifier();
    const platformId = cacheService.GetOktaPlatformId();

    console.log("okta::code", code);
    console.log("okta::codeVerifier", codeVerifier);
    console.log("okta::platformId", platformId);

    if (code !== null && codeVerifier !== null && platformId !== null) {
      const request: LoginOktaRequest = {
        authorizationCode: code,
        codeVerifier: codeVerifier,
        platformId: platformId,
      };

      oktaService.Login(request).then(function (response) {
        setLoading(false);

        if (response.success && response.sessionKey)
          navigate(routePaths.login.path + "/" + response.sessionKey + (response.isNewUser ? "?new" : ""));
        else setError(response.message || t("alert:error.logginInWithOkta"));
      });
    } else {
      setLoading(false);
      setError(t("alert:error.missingParamsToAuthorizeOktaSessionCheck"));
      console.warn("okta::missing params to make auth check.");
    }
  }, []);

  return (
    <>
      {loading && <Typography>{t("page:body.loggingInWithOkta")}</Typography>}
      {error !== "" && <Typography>{t("alert:error.problemConnectWithOkta", { error })}</Typography>}
    </>
  );
};

export default LoginOkta;
